import { Box, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import conversionService from "../../../services/conversion";
import companyService from "../../../services/company";
import invoicesService from "../../../services/invoices";
import CloseIcon from "@mui/icons-material/Close";

import SimpleDialog from "../../ui/SimpleDialog";
import CompanyData from "./CompanyData";
import BaseSelect from "../../ui/BaseSelect";
import BasePreviewFile from "../BasePreviewFile";
import NewInvoiceTab1 from "./NewInvoiceTab1";
import ResumeInv from "./ResumeInv";
import moment from "moment";
import AlertDialog from "../../ui/AlertDialog";
import BaseButton from "../../ui/BaseButton";
import allCurrenciesJs from "../../Js/allCurrencies";
import { fetchFileFromS3 } from "../../../utils/utils";
import countriesProject from "../../Js/countries";

const NewInvoice = (props) => {
    const {
        valueAddInv,
        setShowNewInv,
        setIsLoading,
        setTexto,
        setAlertType,
        setShow,
        replaceInvBill,
        fileData,
        fileNameFull,
        conversionData,
        conversion_type,
        setCurrentInv,
        currentInv,
        setConversionData,
        setFileData,
        reloadInvoices,
        resetConversionInvoices,
        integration,
        isLoading,
    } = props;

    const [t] = useTranslation("global");

    const generateUniqueId = () => Date.now().toString(36) + Math.random().toString(36).substring(2, 9);

    const insertLine = {
        new: true,
        item_code: "",
        description: "",
        amount: 0,
        unit_price: 0,
        original_unit_price: 0,
        quantity: 0,
        account_code: "",
        account_code_json: null,
        tax_type: "",
        tax_type_json: null,
        tax_amount: 0,
        discount: 0,
        tracking1: {},
        tracking2: {},
    };

    const todos = useSelector((state) => state.value);
    const [currency, setCurrency] = useState("");
    const [allCurrencies, setAllCurrencies] = useState([]);
    const [rate, setRate] = useState("");
    const [systemCurrency, setSystemCurrency] = useState("");
    const [invInfo, setInvInfo] = useState({
        invoiceType: conversion_type,
        invoiceNumber: conversionData.formatted_invoice_id ?? "",
        controlNumber: conversionData.control_number ?? "",
        invoiceDate: conversionData.final_date ? moment(conversionData.final_date) : null,
        invoiceDueDate: conversionData.final_due_date ? moment(conversionData.final_due_date) : null,
        contactXeroID: conversionData.contactXeroID ?? "",
        contactXeroName: conversionData?.contact_name_xero ?? "",
        currency: conversionData.final_currency ?? "",
        details: conversionData.observations ?? "",
        contact_tax_type: conversionData?.contact_tax_type ?? [],
        contact_account_code: conversionData?.contact_account_code ?? [],
    });
    const [contactsXeroOriginal, setContactsXeroOriginal] = useState([]);
    const [showCompanyDet, setShowCompanyDet] = useState(false);
    const [accountPrev, setAccountPrev] = useState(0);
    const [rows, setRows] = useState([]);
    const [edited, setEdited] = useState([]);
    const [editGlobal, setEditGlobal] = useState(false);
    const [accountsXero, setAccountsXero] = useState([]);
    const [xeroTaxRates, setXeroTaxRates] = useState([]);
    const [selected, setSelected] = useState([]);
    const [rowsModal, setRowsModal] = useState([]);
    const [openAlert, setOpenAlert] = useState(false);
    const [invChanges, setInvChanges] = useState(false);
    const previousRowsRef = useRef(null);
    const previousInvInfoRef = useRef(null);
    const [openAlertChanges, setOpenAlertChanges] = useState(false);
    const [xeroItems, setXeroItems] = useState([]);
    const [trackingCategories, setTrackingCategories] = useState([]);
    const [trackingConfig, setTrackingConfig] = useState(false);
    const [canApprove, setCanApprove] = useState(!(todos.userRol === 3)); // Si el usuario es Rol 3, no puede aprobar facturas por defecto, a menos que la empresa tenga configurado que sí pueda.

    const [totalsInfo, setTotalsInfo] = useState({
        subtotal: 0.0,
        discount: 0.0,
        tax: 0.0,
        total: 0.0,
    });

    const goBack = () => {
        setCurrentInv({});
        setConversionData({});
        setInvInfo({
            invoiceType: conversion_type,
            invoiceNumber: "",
            controlNumber: "",
            invoiceDate: null,
            invoiceDueDate: null,
            contactXeroID: "",
            contactXeroName: "",
            currency: "",
            details: "",
        });

        setTotalsInfo({
            subtotal: 0.0,
            discount: 0.0,
            tax: 0.0,
            total: 0.0,
        });
        setShowNewInv(false);
        setRows([]);
        setRowsModal([]);
        setFileData(null);
        reloadInvoices();
        resetConversionInvoices();
    };

    const [openPreview, setOpenPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState({});

    const [companyInfo, setCompanyInfo] = useState({
        _id: "",
        // Información de la empresa
        company_name: "",
        company_tax_number: "",
        company_email: "",
        company_address: "",
        company_country: "",
        company_phone: "",
        company_country_code: "",
        // Información del contacto
        contact_name_2: "",
        contact_email_2: "",
        contact_country_2: "",
        contact_phone_2: "",
        contact_role_2: "",
        contact_country_code: "",
    });

    const [selectedContact, setSelectedContact] = useState({});

    const handleCloseModal = () => {
        setShowCompanyDet(false);
    };

    useEffect(() => {
        (async () => {
            setIsLoading(true);

            let taxRates = [];
            let accXero = [];
            await conversionService
                .getTaxRates({
                    company_id: todos.companyID,
                    type: 2, // 2 o 3
                })
                .then((data) => {
                    taxRates = data.map((item) => ({
                        value: item.TaxType,
                        name: `${item.Name} - ${item.EffectiveRate}%`,
                        taxRate: item.EffectiveRate,
                        EffectiveRate: item.EffectiveRate,
                        isZeroTax: item.TaxComponents[0].Name === "No Tax",
                    }));

                    setXeroTaxRates(taxRates);
                })
                .catch((err) => {
                    console.log(err);
                });

            await conversionService
                .getChartOfAccounts({
                    company_id: todos.companyID,
                    type: conversion_type === 1 ? 3 : 2,
                })
                .then((data) => {
                    accXero = data.map((item) => ({ value: item.Code, name: item.Name }));
                    setAccountsXero(accXero);
                })
                .catch((err) => {
                    console.log(err);
                });

            if (Object.keys(conversionData).length > 0) {
                setCurrentInv(conversionData);

                if (conversionData?.line_items) {
                    let fRows = conversionData.line_items.map((item) => {
                        let accSug = "";
                        if (conversionData?.contact_account_code?.length > 0)
                            accSug = conversionData?.contact_account_code[0].AccountCode;

                        let taxSug = taxRates.find((tax) => tax.isZeroTax)?.value ?? "";
                        if (conversionData?.contact_tax_type?.length > 0)
                            taxSug = conversionData?.contact_tax_type[0].TaxType;

                        return {
                            ...item,
                            _id: item._id,
                            item_code: item.code ?? "",
                            description: item.description_xero ?? item.description ?? "",
                            amount: item.amount_xero ?? item.formatted_amount ?? 0,
                            unit_price: item.unit_price_xero ?? item.formatted_unit_price ?? 0,
                            original_unit_price: item.unit_price_xero ?? item.formatted_unit_price ?? 0,
                            quantity: item.quantity_xero ?? item.formatted_quantity ?? 0,
                            account_code:
                                "account_code" in item && item.account_code !== "" ? item.account_code : accSug,
                            account_code_json:
                                "account_code" in item && item.account_code !== ""
                                    ? accXero.find((acc) => acc.value === item.account_code)
                                    : accSug
                                    ? accXero.find((acc) => acc.value === accSug)
                                    : null,
                            discount: item.discount ?? 0,
                            tax_type:
                                "tax_type_xero" in item && item.tax_type_xero !== "" ? item.tax_type_xero : taxSug,
                            tax_type_json:
                                "tax_type_xero" in item && item.tax_type_xero !== ""
                                    ? taxRates.find((tax) => tax.value === item.tax_type_xero)
                                    : taxSug
                                    ? taxRates.find((tax) => tax.value === taxSug)
                                    : null,
                            tax_amount: item.tax_amount_xero ?? item.tax_amount ?? 0,
                            tracking1: item.tracking1 ?? {},
                            tracking2: item.tracking2 ?? {},
                        };
                    });
                    setRows(fRows);
                    let compareBDRows = conversionData.line_items.map((item) => {
                        return {
                            _id: item._id,
                            item_code: item?.code ?? "",
                            description: item?.description_xero ?? item?.description ?? "",
                            amount: item?.amount_xero ?? item?.formatted_amount ?? 0,
                            unit_price: item?.unit_price_xero ?? item?.formatted_unit_price ?? 0,
                            original_unit_price: item?.unit_price_xero ?? item?.formatted_unit_price ?? 0,
                            quantity: item?.quantity_xero ?? item?.formatted_quantity ?? 0,
                            account_code: item?.account_code ?? "",
                            discount: item?.discount ?? 0,
                            tax_type: item?.tax_type_xero ?? "",
                            tax_amount: item?.tax_amount_xero ?? item?.tax_amount ?? 0,
                            tracking1: item?.tracking1 ?? {},
                            tracking2: item?.tracking2 ?? {},
                        };
                    });

                    let compareNewRows = fRows.map((item) => {
                        return {
                            _id: item._id,
                            item_code: item.item_code,
                            description: item.description,
                            amount: item.amount,
                            unit_price: item.unit_price,
                            original_unit_price: item.original_unit_price,
                            quantity: item.quantity,
                            account_code: item.account_code,
                            discount: item.discount,
                            tax_type: item.tax_type,
                            tax_amount: item.tax_amount,
                            tracking1: item.tracking1,
                            tracking2: item.tracking2,
                        }
                    });
                    
                    // Se debe comparar los campos más importantes de lo que está en BD con los rows nuevos (porque a veces se setean sugerencias en los Rows que no están en BD todavía), para saber si habilitar o no botón de Guardar cambios
                    if (JSON.stringify(compareBDRows) !== JSON.stringify(compareNewRows)) {
                        // previousRowsRef.current = fRows;
                        let BDrows = conversionData.line_items.map((item) => {
                            return {
                                ...item,
                                _id: item._id,
                                item_code: item?.code ?? "",
                                description: item?.description_xero ?? item?.description ?? "",
                                amount: item?.amount_xero ?? item?.formatted_amount ?? 0,
                                unit_price: item?.unit_price_xero ?? item?.formatted_unit_price ?? 0,
                                original_unit_price: item?.unit_price_xero ?? item?.formatted_unit_price ?? 0,
                                quantity: item?.quantity_xero ?? item?.formatted_quantity ?? 0,
                                account_code: item?.account_code ?? "",
                                discount: item?.discount ?? 0,
                                tax_type: item?.tax_type_xero ?? "",
                                tax_amount: item?.tax_amount_xero ?? item?.tax_amount ?? 0,
                                tracking1: item?.tracking1 ?? {},
                                tracking2: item?.tracking2 ?? {},
                            };
                        });
                        previousRowsRef.current = BDrows;
                    } else {
                        previousRowsRef.current = fRows;
                    }
                } else {
                    if (rows.length === 0) {
                        const newId = generateUniqueId();
                        let newLine = {
                            _id: newId,
                            ...insertLine,
                        };
                        setRows([newLine]);
                        handleEditRow(newId, false, [...rows, newLine], true);
                    }
                }
            } else {
                if (rows.length === 0) {
                    const newId = generateUniqueId();
                    let newLine = {
                        _id: newId,
                        ...insertLine,
                    };
                    setRows([newLine]);
                    handleEditRow(newId, false, [...rows, newLine], true);
                }
            }

            if (fileData) {
                setOpenPreview(true);
                setPreviewFile({ fileName: fileNameFull, fileData: fileData });
                let newRows = [
                    {
                        id: 0,
                        file_name: fileNameFull,
                        file_name_s3: conversionData.file_name,
                    },
                ];

                let finalArr = [];

                if (conversionData.additional_files?.length > 0) {
                    const auxArr = conversionData.additional_files.map((item) => ({
                        id: item._id,
                        file_name: item.uploaded_file,
                        file_name_s3: item.uploaded_file_s3,
                    }));
                    finalArr = newRows.concat(auxArr);
                } else {
                    finalArr = [...newRows];
                }

                setRowsModal(finalArr);
            }
            let companyCurrency = "";
            let companyInteg = "";
            await companyService
                .getCompanyDetails(todos.companyID)
                .then((data) => {
                    if (data.system_currency) setSystemCurrency(data.system_currency);
                    companyCurrency = data.system_currency;
                    companyInteg = data.system_integration;
                    if ("tracking_config" in data) setTrackingConfig(data.tracking_config);
                    if ("can_approve_invoice" in data && todos.userRol === 3) setCanApprove(data.can_approve_invoice);
                })
                .catch((error) => {
                    console.log(error);
                });

            if (allCurrenciesJs.length > 0) {
                const currencyMap = allCurrenciesJs.map((item) => ({
                    id: item.Code,
                    name: item.Description,
                }));
                setAllCurrencies(currencyMap);
                const findCurrency = conversionData.final_currency
                    ? currencyMap.find((currency) => currency.id === conversionData.final_currency)
                    : companyInteg !== 3
                    ? currencyMap.find((currency) => currency.id === companyCurrency)
                    : null;

                setCurrency(findCurrency?.id ?? "");
            }

            await conversionService
                .getContacts({
                    company_id: todos.companyID,
                })
                .then((data) => {
                    setContactsXeroOriginal(
                        data.map((item) => ({
                            ...item,
                            value: item.ContactID,
                            name: item.Name,
                            currency: item.currency_contact,
                            idSys: item.contact_id_system,
                        }))
                    );
                })
                .catch((err) => {
                    console.log(err);
                });

            await conversionService
                .getXeroItems({
                    company_id: todos.companyID,
                    type: conversion_type,
                })
                .then((data) => {
                    setXeroItems(data.map((item) => ({ value: item.ItemID, name: item.Name, code: item.Code })));
                })
                .catch((err) => {
                    console.log(err);
                });

            await conversionService
                .getTrackingCategories({
                    company_id: todos.companyID,
                })
                .then((data) => {
                    // let fData = [
                    //     {"_id":"67647216f6a02f3cce315041","company_id":"6762fec048c4b4eb1a5f550a","tracking_category_id_xero":"308f7463-6c99-44fe-8b9c-e105416ecf35","tracking_category_name_xero":"Department","tracking_category_options":[{"TrackingOptionID":"b70cd8c6-baba-49ab-b8b9-f1768708c9eb","Name":"000 San Francisco - US Hispanic","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"7c6782ee-0c20-4371-8765-8587948782e4","Name":"001 Oakland - Fruitvale","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"c1d8fade-164f-489e-b516-3161860c3a81","Name":"002 San Francisco - Mission","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"f307e0a5-c1bf-4fda-8e09-c2743dc41e68","Name":"003 California - Redwood City","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"b958ed83-cf1d-416f-a820-f972449a462f","Name":"004 San Jose - Story","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"146c6221-bfd7-4423-ab6b-08894b7aabb7","Name":"006 California - Hayward","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"8395c9da-cd69-4802-adf0-05ff4439d26f","Name":"007 California - San Mateo","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"ee2dbf2e-10d6-4d4b-894a-3c5ec771e07e","Name":"008 Warehouse - Local","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"1c6ca014-6333-459c-ae05-782c11b3c615","Name":"009 Milagros Money - Local","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"3ae76c42-c05c-4e91-8cff-5c9bfeabb2ce","Name":"010 Los Angeles - Cudahy","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"6afa1f2e-d088-4e74-a7be-4793dd65ca36","Name":"011 Aldine - Houston Texas","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"210af001-e984-49fc-a5f2-7f225207801d","Name":"012 Northbrook - Houston Texas","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"51216ddf-82c4-41b4-9c7c-5abd2c60f7cb","Name":"013 Huntington Park - LA","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"375eb264-26b0-4e14-a5a2-46c7c1ad3878","Name":"014 Hickory - Houston Texas","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"f40c5e65-8334-4b8e-91e0-9bbdc2320bb1","Name":"015 E-commerce - Local","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"c91cdd33-714a-4b94-ae7e-afa4dda8ebfc","Name":"016 MM - Cudahy LA","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"5ab1b356-25b4-4594-acec-0a3c0dd6f1f7","Name":"016 MM - Hayward CA","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"69216636-fe4f-424c-a270-bb26954ff6ed","Name":"016 MM - San Jose Story","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"bc0db800-5387-450b-b247-6385002fa95d","Name":"016 MM- Mission SF","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"5017395e-2101-4d28-850f-7542d03efa1c","Name":"016 MM- Redwood City CA","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"f041f17f-5473-4174-b08e-d289d5ad03fc","Name":"016 Wholesales - Local","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"6399df93-8032-4ca8-b260-9c249f192c44","Name":"Corporate - Local","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true},{"TrackingOptionID":"282a543d-a3b1-4c77-868a-18118ca52c84","Name":"E-commerce","Status":"ACTIVE","HasValidationErrors":false,"IsDeleted":false,"IsArchived":false,"IsActive":true}]}
                    // ]
                    setTrackingCategories(data);
                })
                .catch((err) => {
                    console.log(err);
                });

            setIsLoading(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setIsLoading, todos.companyID]);

    const accountsPrev = rowsModal.map((item) => ({ id: item.id, name: item.file_name }));

    const handleChangeDoc = async (event) => {
        setIsLoading(true);

        const found = rowsModal.find((item) => item.id === event.target.value);

        const data = await fetchFileFromS3(found.file_name_s3);

        setPreviewFile({
            fileName: found.file_name,
            fileData: data,
        });

        setAccountPrev(event.target.value);

        setIsLoading(false);
    };

    const handleHidePrev = () => setOpenPreview(false);

    useEffect(() => {
        // Actualizar total en factura cada vez que cambian los items
        const getSubTotal = () => {
            return rows.filter((row) => !row.deleted).reduce(function (sum, item) {
                return sum + (item?.unit_price ?? 0.0) * (item?.quantity ?? 0);
            }, 0.0);
        };

        const getDiscount = () => {
            return rows.filter((row) => !row.deleted).reduce(function (sum, item) {
                return sum + ((item?.unit_price ?? 0.0) * (item?.quantity ?? 0) * (item?.discount ?? 0)) / 100;
            }, 0.0);
        };

        const getTaxes = () => {
            return rows.filter((row) => !row.deleted).reduce(function (sum, item) {
                const taxRate = Number(xeroTaxRates.find((tax) => tax?.value === item?.tax_type)?.taxRate || 0);
                return sum + ((item?.unit_price ?? 0.0) * (item?.quantity ?? 0) * (taxRate ?? 0)) / 100;
            }, 0.0);
        };

        const getTotal = () => {
            return rows.filter((row) => !row.deleted).reduce(function (sum, item) {
                const subTotal = (item?.unit_price ?? 0.0) * (item?.quantity ?? 0);
                const taxRate = Number(xeroTaxRates.find((tax) => tax?.value === item?.tax_type)?.taxRate || 0);
                return sum + subTotal + (subTotal * (taxRate ?? 0)) / 100 - (subTotal * (item?.discount ?? 0)) / 100;
            }, 0.0);
        };

        setTotalsInfo({
            subtotal: getSubTotal(),
            discount: getDiscount(),
            tax: getTaxes(),
            total: getTotal(),
        });
    }, [rows, xeroTaxRates]);

    useEffect(() => {
        // Compara si rows o invInfo han cambiado respecto a los valores anteriores

        let copyInv = JSON.parse(JSON.stringify(invInfo));
        let copyRows = [...rows];
        const rowsChanged = JSON.stringify(previousRowsRef.current) !== JSON.stringify(copyRows);
        const invInfoChanged = JSON.stringify(previousInvInfoRef.current) !== JSON.stringify(copyInv);

        // Solo actualizar si currentInv.id_status es 4 y hay cambios en rows o invInfo
        if ((currentInv.id_status === 4 || currentInv.id_status === 2) && (rowsChanged || invInfoChanged)) {
            setInvChanges(true);
        } else {
            setInvChanges(false);
        }
    }, [rows, invInfo, currentInv]);

    const bodyMess = (
        <>
            <Typography
                fontStyle="normal"
                fontSize={14}
                fontWeight={300}
                sx={{
                    color: "#131F3E",
                    mt: 2,
                }}
                textAlign="justify"
            >
                {replaceInvBill(t("invoicing.unsavedChangesWarning"))}
            </Typography>
            <Typography
                fontStyle="normal"
                fontSize={14}
                fontWeight={300}
                sx={{
                    color: "#131F3E",
                    mt: 2,
                    mb: 3,
                }}
                textAlign="justify"
            >
                {replaceInvBill(t("invoicing.confirmExitWithoutSaving"))}
            </Typography>
        </>
    );

    const handleCloseDialog = () => {
        setOpenAlert(false);
    };

    const handleAlertModal = () => {
        if (Object.keys(currentInv).length === 0) {
            setOpenAlert(true);
        } else {
            goBack();
        }
    };

    const handleAlertModalSendInv = async () => {
        setIsLoading(true);

        const fItems = currentInv.line_items.filter((item) => !item?.deleted)
            .map((item) => {
                let fTracking = [];
                if (item?.tracking1 && Object.keys(item?.tracking1).length > 0) fTracking.push(item?.tracking1);

                if (item?.tracking2 && Object.keys(item?.tracking2).length > 0) fTracking.push(item?.tracking2);

                return {
                    ...item,
                    item_code:
                        "code" in item && item.code !== null && item.code !== ""
                            ? xeroItems.find((xItem) => xItem.value === item.code)?.code
                            : "",
                    tracking: fTracking,
                };
            })
            .filter((item) => !item?.deleted);

        const contactData = contactsXeroOriginal?.find(
            (item) => item?._id.toString() === selectedContact?._id?.toString()
        );

        const paramsSync = {
            invoices: [
                {
                    _id: currentInv._id,
                    ContactInternal: contactData,
                    currency: currency,
                    currency_rate: rate ?? 1,
                    invoice_date: moment(invInfo?.invoiceDate).format("YYYY-MM-DD"),
                    invoice_due_date: moment(invInfo?.invoiceDueDate).format("YYYY-MM-DD"),
                    line_items: JSON.stringify(fItems),
                    formatted_invoice_id: invInfo.invoiceNumber,
                },
            ],
        };

        await invoicesService
            .markInvoiceAsApproved({
                invoice_id: currentInv._id,
                sync_data: paramsSync,
            })
            .then(async (response) => {
                let params2 = { invoice_id: response.data._id, conversion_type: conversion_type };
                await invoicesService
                    .getAIInvoiceDetails(params2)
                    .then((data) => {
                        setConversionData(data.invoice);
                    })
                    .catch((err) => {
                        console.log(err);
                    });

                setCurrentInv(response.data);
                // let fRows = response.data.line_items.map((item) => {
                //     const zeroTaxAccountCode = xeroTaxRates.find((tax) => tax.isZeroTax)?.value ?? "";
                //     return {
                //         ...item,
                //         _id: item._id,
                //         item_code: item?.code ?? "",
                //         description: item?.description ?? "",
                //         amount: item?.formatted_amount ?? 0,
                //         unit_price: item?.formatted_unit_price ?? 0,
                //         original_unit_price: item?.formatted_unit_price ?? 0,
                //         quantity: item?.formatted_quantity ?? 0,
                //         account_code: item?.account_code ?? "",
                //         account_code_json:
                //             "account_code" in item && item?.account_code !== "" && item?.account_code !== null
                //                 ? accountsXero.find((acc) => acc.value === item.account_code)
                //                 : null,
                //         discount: item?.discount ?? 0,
                //         tax_type: item?.tax_type_xero ?? zeroTaxAccountCode,
                //         tax_type_json:
                //             "tax_type_xero" in item && item?.tax_type_xero !== "" && item?.tax_type_xero !== null
                //                 ? xeroTaxRates.find((tax) => tax.value === item.tax_type_xero)
                //                 : xeroTaxRates.find((tax) => tax.value === zeroTaxAccountCode),
                //         tax_amount: item?.tax_amount ?? 0,
                //     };
                // });
                // previousRowsRef.current = fRows;
                previousInvInfoRef.current = invInfo;
                // setOpenAlertSendInv(true);
                setTexto(t("register.saveSuccessfully"));
                setAlertType("success");
                setShow(true);
            })
            .catch((err) => {
                console.log(err);
            });

        setIsLoading(false);

        // await updateInvoice(true);
    };

    const handleCloseDialogChanges = () => {
        setOpenAlertChanges(false);
    };

    const calcSubtotal = (obj) => {
        return parseFloat(obj.unit_price ?? 0) * parseFloat(obj.quantity ?? 1);
    };

    const calcTax = (obj) => {
        if (xeroTaxRates.length > 0 && "tax_type" in obj && obj.tax_type !== "") {
            const taxRate = xeroTaxRates.find((item) => item.value === obj.tax_type).taxRate;
            return (taxRate * calcSubtotal(obj)) / 100;
        }
    };

    const calcTotal = (obj) => {
        return calcTax(obj) + calcSubtotal(obj);
    };

    /** Countries */
    const allCountries = [...countriesProject];

    allCountries.sort((a, b) => {
        if (sessionStorage.getItem("lng") === "en") {
            return a.name_en.localeCompare(b.name_en);
        } else {
            return a.name_es.localeCompare(b.name_es);
        }
    });

    function validateValue(value) {
        return value !== undefined && value !== null && value !== "";
    }

    const updateInvoice = async (setApprove = false, finalItems) => {
        setOpenAlertChanges(false);
        const copyInv = JSON.parse(JSON.stringify(invInfo));
        const copyRows = [...rows];

        let codeFilter1 = allCountries.find((country) => country.country_code === companyInfo?.company_country);
        let codeFilter2 = allCountries.find((country) => country.country_code === companyInfo?.contact_country_2);

        const fInvInfo = {
            invoice_id: currentInv._id,
            invoice: {
                contact_updated_id: selectedContact ?? "",
                contactXeroID: copyInv.contactXeroID !== "first" ? copyInv.contactXeroID : undefined,
                contactXeroName: copyInv.contactXeroName,
                // currency: "",
                // total: "",
                company_id: todos?.companyID,
                observations: copyInv.details,
                conversion_type: conversion_type,
                invoice_type: copyInv.invoiceType,
                invoice_id: copyInv.invoiceNumber,
                control_number: copyInv.controlNumber,
                invoice_date: copyInv.invoiceDate,
                due_date: copyInv.invoiceDueDate,
                currency_rate: rate, //Tasa de cambio.
                sub_total: totalsInfo.subtotal, //Subtotal.
                invoice_tax: totalsInfo.tax, //Tax.
                invoice_discount: totalsInfo.discount, //Descuento.
                invoice_total: totalsInfo.total, //Total.
                // line_items: //Array de objetos con las siguientes propiedades:
                currency: currency,
                approve: setApprove,

                company_name: validateValue(companyInfo.company_name) ? companyInfo.company_name : undefined,
                company_tax_number: validateValue(companyInfo.company_tax_number)
                    ? companyInfo.company_tax_number
                    : undefined,
                company_email: validateValue(companyInfo.company_email) ? companyInfo.company_email : undefined,
                company_address: validateValue(companyInfo.company_address) ? companyInfo.company_address : undefined,
                company_country: codeFilter1?.code && codeFilter1.code !== "" ? codeFilter1.code : undefined,
                company_phone: validateValue(companyInfo.company_phone) ? companyInfo.company_phone : undefined,

                contact_name: validateValue(companyInfo.contact_name_2) ? companyInfo.contact_name_2 : undefined,
                contact_email: validateValue(companyInfo.contact_email_2) ? companyInfo.contact_email_2 : undefined,
                contact_country: codeFilter2?.code && codeFilter2.code !== "" ? codeFilter2.code : undefined,
                contact_phone: validateValue(companyInfo.contact_phone_2) ? companyInfo.contact_phone_2 : undefined,
                contact_role: validateValue(companyInfo.contact_role_2) ? companyInfo.contact_role_2 : undefined,

                line_items: finalItems
                    ? currentInv.line_items
                    : copyRows.map((item) => ({
                          _id: item?._id ?? undefined,
                          code: item.code, //Código.
                          description: item.description, //Descripción.
                          quantity: item.quantity, //Cantidad.
                          unit_price: item.unit_price, //Precio unitario.
                          account_code: item.account_code, //Cuenta contable.
                          discount: item.discount, //Descuento.
                          tracking1: Object.keys(item?.tracking1).length > 0 ? item?.tracking1 : undefined, //Tracking 1,
                          tracking2: Object.keys(item?.tracking2).length > 0 ? item?.tracking2 : undefined, //Tracking 2,
                          tax_type: item.tax_type,
                          tax_amount: calcTax(item), //Monto de impuestos.
                          amount: calcTotal(item), //Monto total de la línea
                          deleted: item.deleted,
                      })),
            },
        };

        setIsLoading(true);
        await invoicesService
            .updateInvoice(fInvInfo)
            .then(async (response) => {
                // console.log("response.data", response.data);
                await conversionService
                    .getContacts({
                        company_id: todos.companyID,
                    })
                    .then((data) => {
                        setContactsXeroOriginal(
                            data.map((item) => ({
                                ...item,
                                value: item.ContactID,
                                name: item.Name,
                                currency: item.currency_contact,
                                idSys: item.contact_id_system,
                            }))
                        );
                    })
                    .catch((err) => {
                        console.log(err);
                    });

                let params2 = { invoice_id: response.data._id, conversion_type: conversion_type };
                await invoicesService
                    .getAIInvoiceDetails(params2)
                    .then((data) => {
                        setConversionData(data.invoice);
                    })
                    .catch((err) => {
                        console.log(err);
                    });

                setCurrentInv(response.data);
                previousInvInfoRef.current = invInfo;
                let fRows = response.data.line_items.map((item) => {
                    const zeroTaxAccountCode = xeroTaxRates.find((tax) => tax.isZeroTax)?.value ?? "";
                    return {
                        ...item,
                        _id: item._id,
                        item_code: item?.code ?? "",
                        description: item?.description ?? "",
                        amount: item?.formatted_amount ?? 0,
                        unit_price: item?.formatted_unit_price ?? 0,
                        original_unit_price: item?.formatted_unit_price ?? 0,
                        quantity: item?.formatted_quantity ?? 0,
                        account_code: item?.account_code ?? "",
                        account_code_json:
                            "account_code" in item && item?.account_code !== "" && item?.account_code !== null
                                ? accountsXero.find((acc) => acc.value === item.account_code)
                                : null,
                        discount: item?.discount ?? 0,
                        tax_type: item?.tax_type_xero ?? zeroTaxAccountCode,
                        tax_type_json:
                            "tax_type_xero" in item && item?.tax_type_xero !== "" && item?.tax_type_xero !== null
                                ? xeroTaxRates.find((tax) => tax.value === item.tax_type_xero)
                                : xeroTaxRates.find((tax) => tax.value === zeroTaxAccountCode),
                        tax_amount: item?.tax_amount ?? 0,
                        tracking1: item?.tracking1 ?? {},
                        tracking2: item?.tracking2 ?? {},
                    };
                });
                setRows(fRows);
                previousRowsRef.current = fRows;
                setTexto(t("register.saveSuccessfully"));
                setAlertType("success");
                setShow(true);
            })
            .catch((err) => {
                console.log(err);
            });
        setIsLoading(false);
    };

    const bodyMess3 = (
        <>
            <Typography
                fontStyle="normal"
                fontSize={14}
                fontWeight={300}
                sx={{
                    color: "#131F3E",
                    mt: 2,
                }}
                textAlign="justify"
            >
                {t("invoicing.confirmChangesMessage")}
            </Typography>
        </>
    );

    const handleModalupdateInvoice = async () => {
        if (currentInv.id_status === 4) {
            setOpenAlertChanges(true);
        } else {
            await updateInvoice(false);
        }
    };

    const handleEditRow = (id, isEdited, rowsParam, fromAddRow) => {
        if (!isEdited) {
            setEditGlobal(!editGlobal);
        }

        const checkedIndex = edited.indexOf(id);
        let newChecked = [];

        if (checkedIndex === -1) {
            newChecked = newChecked.concat(edited, id);
        } else if (checkedIndex === 0) {
            newChecked = newChecked.concat(edited.slice(1));
        } else if (checkedIndex === edited.length - 1) {
            newChecked = newChecked.concat(edited.slice(0, -1));
        } else if (checkedIndex > 0) {
            newChecked = newChecked.concat(edited.slice(0, checkedIndex), edited.slice(checkedIndex + 1));
        }

        if (!isEdited) {
            setEdited(newChecked);
        }

        if (isEdited) {
            let findEdited = rowsParam.find((e) => e._id === id);
            if (findEdited?.new) {
                if (findEdited.description !== "") {
                    setEditGlobal(!editGlobal);
                    setEdited(newChecked);
                } else {
                    setTexto(t("converter.cannotBeSaveInv"));
                    setAlertType("error");
                    setShow(true);
                }
            } else {
                if (findEdited.description !== "") {
                    setEditGlobal(!editGlobal);
                    setEdited(newChecked);
                } else {
                    setTexto(t("converter.cannotBeSaveInv"));
                    setAlertType("error");
                    setShow(true);
                }
            }
        } else {
            if (!fromAddRow) {
                let findEdited = rowsParam.find((e) => e._id === id);
                if (findEdited?.new) {
                    if (findEdited.description !== "") {
                        setRows(rowsParam);
                    } else {
                        // Se descarta la línea
                        const filterRows = rowsParam.filter((item) => item._id !== id);
                        setRows(filterRows);
                    }
                } else {
                    setRows(rowsParam);
                }
            } else {
                setRows(rowsParam);
            }
        }
    };

    return (
        <>
            <Box
                sx={{
                    backgroundColor: "#F8F8F9",
                    p: 3,
                }}
            >
                <BaseButton variantType="primaryOutlined" onClick={handleAlertModal} sizebutton="m">
                    {t("miscellaneous.goBack")}
                </BaseButton>
                <Grid container spacing={2} mt={0.5}>
                    {openPreview && valueAddInv !== 1 && (
                        <Grid item xs={12} md={4}>
                            <Stack
                                direction="row"
                                spacing={2}
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{
                                    backgroundColor: "white",
                                    p: 2,
                                    mb: 1,
                                    // boxShadow: "4px 4px 10px rgba(74, 34, 212, 0.1)",
                                }}
                            >
                                <Box sx={{ width: 250 }}>
                                    <BaseSelect
                                        value={accountPrev}
                                        values={accountsPrev}
                                        onChange={handleChangeDoc}
                                        label={t("management.attachment")}
                                    ></BaseSelect>
                                </Box>
                                <BaseButton variantType="errorText" endIcon={<CloseIcon />} onClick={handleHidePrev}>
                                    {t("management.hide")}
                                </BaseButton>
                            </Stack>
                            <BasePreviewFile filename={previewFile.fileName} filedata={previewFile.fileData} />
                        </Grid>
                    )}
                    <Grid
                        item
                        xs={12}
                        md={openPreview ? 8 : valueAddInv === 1 || valueAddInv === 2 ? 7 : 12}
                        sx={{ borderRadius: "8px", mt: 2 }}
                    >
                        <NewInvoiceTab1
                            setShowCompanyDet={setShowCompanyDet}
                            invInfo={invInfo}
                            setInvInfo={setInvInfo}
                            setCurrency={setCurrency}
                            systemCurrency={systemCurrency}
                            setRate={setRate}
                            setRows={setRows}
                            setTexto={setTexto}
                            setAlertType={setAlertType}
                            setShow={setShow}
                            rows={rows}
                            xeroTaxRates={xeroTaxRates}
                            setIsLoading={setIsLoading}
                            setPreviewFile={setPreviewFile}
                            setAccountPrev={setAccountPrev}
                            setOpenPreview={setOpenPreview}
                            contactsXeroOriginal={contactsXeroOriginal}
                            currency={currency}
                            rate={rate}
                            allCurrencies={allCurrencies}
                            selected={selected}
                            setSelected={setSelected}
                            accountsXero={accountsXero}
                            replaceInvBill={replaceInvBill}
                            conversion_type={conversion_type}
                            setCurrentInv={setCurrentInv}
                            currentInv={currentInv}
                            handleAlertModalSendInv={handleAlertModalSendInv}
                            goBack={goBack}
                            invChanges={invChanges}
                            previewFile={previewFile}
                            previousRowsRef={previousRowsRef}
                            previousInvInfoRef={previousInvInfoRef}
                            handleModalupdateInvoice={handleModalupdateInvoice}
                            setRowsModal={setRowsModal}
                            rowsModal={rowsModal}
                            conversionData={conversionData}
                            updateInvoice={updateInvoice}
                            handleEditRow={handleEditRow}
                            xeroItems={xeroItems}
                            integration={integration}
                            setSelectedContact={setSelectedContact}
                            selectedContact={selectedContact}
                            trackingCategories={trackingCategories}
                            setCompanyInfo={setCompanyInfo}
                            companyInfo={companyInfo}
                            totalsInfo={totalsInfo}
                            isLoading={isLoading}
                            trackingConfig={trackingConfig}
                            canApprove={canApprove}
                        />
                    </Grid>
                    {valueAddInv === 1 && <ResumeInv />}
                    {/* {valueAddInv === 2 && (
                        <Grid item xs={12} md={5} mt={{ xs: 1, md: "66.75px" }}>
                            <NewInvoiceSendSettings
                                setTexto={setTexto}
                                setAlertType={setAlertType}
                                setShow={setShow}
                                sendEmailInfo={sendEmailInfo}
                                setIsError={setIsErrorTab3}
                            />
                            <NewInvoiceMailingLog />
                        </Grid>
                    )} */}
                </Grid>
                <SimpleDialog
                    open={showCompanyDet}
                    handleClose={handleCloseModal}
                    maxWidth="md"
                    content={
                        <CompanyData
                            setShowCompanyDet={setShowCompanyDet}
                            setIsLoading={setIsLoading}
                            setContactsXeroOriginal={setContactsXeroOriginal}
                            companyInfo={companyInfo}
                            setCompanyInfo={setCompanyInfo}
                            setTexto={setTexto}
                            setAlertType={setAlertType}
                            setShow={setShow}
                            selectedContact={selectedContact}
                            setSelectedContact={setSelectedContact}
                        />
                    }
                />
            </Box>
            <AlertDialog
                open={openAlert}
                onClose={handleCloseDialog}
                agreeBtnLabel={t("dialog.continue")}
                disagreeBtnLabel={t("dialog.cancel")}
                type={"warning"}
                title={t("dialog.warning")}
                message={bodyMess}
                agreeAction={goBack}
                maxWidth="sm"
            />
            {/* <AlertDialog
                open={openAlertSendInv}
                onClose={handleCloseDialogSendInv}
                agreeBtnLabel={t("converter.send")}
                disagreeBtnLabel={t("miscellaneous.goBack")}
                type={"info2"}
                title={"Envío de la factura al cliente"}
                message={bodyMess2}
                agreeAction={sendInvoiceClient}
                maxWidth="sm"
            /> */}
            <AlertDialog
                open={openAlertChanges}
                onClose={handleCloseDialogChanges}
                agreeBtnLabel={t("dialog.continue")}
                disagreeBtnLabel={t("dialog.cancel")}
                type={"info2"}
                title={t("invoicing.approvedInvoiceChanges")}
                message={bodyMess3}
                agreeAction={() => updateInvoice(false)}
                maxWidth="sm"
            />
        </>
    );
};

export default NewInvoice;